
export default function Error() {

    return (
        <div className={'error-container'}>
            <h2>שגיאה! אנא נסה שוב</h2>
        </div>
    );
}